import _ from 'lodash';
import { getUrl } from './helper';
import { authedFunction } from '../session';

export const eventActions = {
  addOrEditEvent: (data) => {
    let url = getUrl('events', 'add');
    if (data.RowId != null) {
      url = getUrl('events', 'edit');
    }
    const request = {
      method: 'POST',
      url,
      data: {
        event: data,
      },
    };
    return authedFunction(request);
  },
  removeEvent: (site, id) => {
    return authedFunction({
      method: 'POST',
      url: getUrl('events', 'remove'),
      data: {
        id,
        site,
      },
    });
  },
  getEvent: (site, id) => {
    return authedFunction({
      method: 'GET',
      url: getUrl('events', `get/${id}`, { site }),
    });
  },
  getEvents: (site, time, includePast) => {
    let query = { site };
    if (time) {
      query.time = time;
    }
    if (includePast) {
      query.includePast = 'true';
    }
    return authedFunction({
      method: 'GET',
      url: getUrl('events', 'get', query),
    });
  },
  getEventsRecursive: async (site, time, includePast, tempResult = []) => {
    let query = { site };
    if (time) {
      query.time = time;
    }
    if (includePast) {
      query.includePast = 'true';
    }
    const result = await authedFunction({
      method: 'GET',
      url: getUrl('events', 'get', query),
    });
    tempResult.push(...result.data);
    if (result.data.length < 100) {
      return { data: _.uniqBy(tempResult, 'RowId') };
    }
    const timeChanged = _.maxBy(tempResult, (event) => {
      if (!event) {
        return 0;
      }
      return event.Changed;
    }).Changed;
    return eventActions.getEventsRecursive(site, timeChanged, includePast, tempResult);
  },
  registerForEvent: async (site, userID, eventId, repId, count, notes) => {
    const request = {
      method: 'POST',
      url: getUrl('eventreps', 'register'),
      data: {
        site,
        userID,
        eventId,
        repId,
        fromAdmin: true,
        count,
        notes,
      },
    };
    return authedFunction(request);
  },
  removeEventAttendee: async (site, userID, eventId, repId) => {
    const request = {
      method: 'POST',
      url: getUrl('eventreps', 'remove'),
      data: {
        site,
        userID,
        eventId,
        repId,
        fromAdmin: true,
      },
    };
    return authedFunction(request);
  },
  confirmEventAttendee: async (site, userID, eventId, repId, confirmed) => {
    const request = {
      method: 'POST',
      url: getUrl('eventreps', 'confirm'),
      data: {
        site,
        userID,
        eventId,
        repId,
        confirmed,
      },
    };
    return authedFunction(request);
  },
  getEventReps: (site, eventId) => {
    let query = { site, eventId };
    return authedFunction({
      method: 'GET',
      url: getUrl('eventreps', 'get', query),
    });
  },
  getUpcomingEventReps: (site, minTime, limit) => {
    let query = { site, minTime, limit };
    return authedFunction({
      method: 'GET',
      url: getUrl('eventreps', 'upcoming', query),
    });
  },
  getEventSubmissions: (site) => {
    return authedFunction({
      method: 'GET',
      url: getUrl('events', 'submissions/get', { site }),
    });
  },
  getEventSubmission: (id) => {
    return authedFunction({
      method: 'GET',
      url: getUrl('events', `submissions/get/${id}`),
    });
  },
  handleEventSubmission: (site, id, action) => {
    return authedFunction({
      method: 'POST',
      url: getUrl('events', 'submissions/handle'),
      data: {
        site,
        id,
        action,
      },
    });
  },
  editSubmission: (event) => {
    return authedFunction({
      method: 'POST',
      url: getUrl('events', 'editSub'),
      data: {
        event,
      },
    });
  },
  getSubmissionCount: (site) => {
    return authedFunction({
      method: 'GET',
      url: getUrl('events', `submissions/count`, { site }),
    });
  },
  getLocationTags: (site) => {
    return authedFunction({
      method: 'GET',
      url: getUrl('events', `tags/location`, { site }),
    });
  },
  deleteLocationTag: (site, tag) => {
    return authedFunction({
      method: 'POST',
      url: getUrl('events', `tags/delete`),
      data: { site, tag, type: 'location' },
    });
  },
  generateCalendar: (site, month, year, time = 0, excludeOutsideMonth = true, weekStartsMonday = false) => {
    return authedFunction({
      method: 'POST',
      url: getUrl('events', `calendar`),
      data: { site, month, year, time, excludeOutsideMonth, weekStartsMonday },
    });
  },
};
